import { motion } from 'framer-motion';
import { BsPhoneFill } from 'react-icons/bs';
import { SiMinutemailer } from 'react-icons/si';
import { socialLinks } from '../../utils/socialLinks';
import { contactAnimation, contactTransition } from '../../animations/contact';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact">
      <motion.div
        className="contact__wrapper"
        initial="out"
        animate="in"
        variants={contactAnimation}
        transition={contactTransition}
      >
        <h2 className="contact__title">Contact Me</h2>
        <p className="contact__text">
          Don't be a stranger, Just say <span>Hello!</span>
        </p>

        <div className="contact__container">
          <form className="contact__form">
            <div className="form__inputBox">
              <input
                className="form__input"
                type="text"
                name="name"
                required
                autoComplete="off"
              />
              <span>Full Name</span>
            </div>
            <div className="form__inputBox">
              <input
                className="form__input"
                type="email"
                name="email"
                required
                autoComplete="do_not_auto_complete"
              />
              <span>Email</span>
            </div>
            <div className="form__inputBox">
              <input
                className="form__input"
                type="text"
                name="subject"
                required
                autoComplete="do_not_auto_complete"
              />
              <span>Subject</span>
            </div>
            <div className="form__inputBox">
              <textarea
                className="form__input"
                name="message"
                rows="3"
                required
              ></textarea>
              <span>Message</span>
            </div>
            <button className="form__button" type="submit">
              Send
            </button>
          </form>

          <div className="contact__information">
            <h3>Contact Information:</h3>
            <p>
              Feel free to get in touch with me. I am always open to discussing
              new projects, creative ideas or opportunities to be part of your
              visions.
            </p>

            <div className="contact__details">
              <BsPhoneFill className="contact__detailsIcon" />
              <a
                href="tel:+254 743 721907"
                target="_blank"
                rel="noopener noreferrer"
              >
                +254 743 721907
              </a>
            </div>
            <div className="contact__details">
              <SiMinutemailer className="contact__detailsIcon" />
              <a
                href="mailto:whiteken2002@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                whiteken2002@gmail.com
              </a>
            </div>

            <ul className="contact__socials">
              {socialLinks.map((link) => {
                const { id, url, icon } = link;
                return (
                  <li key={id}>
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {icon}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Contact;
